// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3A2C3","header":"ReportDetails_header__1juvE","title":"ReportDetails_title__-q9Ea","left":"ReportDetails_left__NX0-2"};